import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, HtmlBase, ZoomModel, ZoomRecordingFile } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


declare var require: any;
const ClassicEditor: any = require('../../../../../../app-queoval/src/assets/ckeditor5/build/ckeditor');

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})

export class TextEditorComponent extends BaseAddOnComponent implements OnInit {
  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  public validator: RegExp | null = null;

  @Input() input: PropertyData;

  public Editor: any = ClassicEditor;
  public viewMode: SafeHtml;
  // #region CONSTRUCTEUR
  constructor(
    private sanitazer: DomSanitizer
  ) { super(); }
  // #endregion

  ngOnInit(): void {
    this.viewMode = this.sanitazer.bypassSecurityTrustHtml(this.input.MainElementList[0].Value);
    if (this.input.MainElementList[0].ValidExp) {
      this.validator = new RegExp(this.input.MainElementList[0].ValidExp);
    }
  }

  public IsUnderLimit(): boolean {
    if (this.validator != null) {
      return this.validator.test(this.input.MainElementList[0].Value);
    }
    return true;
  }

}
